<!-- <button
[ngClass]="type"
(click)="handleClick()"
>
<ng-content></ng-content>
</button> -->

<!-- Apply the button class dynamically based on the type -->
@if (type !== 'next' && type !== 'previous') {
  <button
    [ngClass]="type"
    (click)="handleClick()">
    <ng-content></ng-content>
  </button>
}

<!-- Next button with matStepperNext -->
@if (type === 'next') {
  <button
    matStepperNext
    [ngClass]="type"
    (click)="handleClick()">
    {{'GLOBAL_BUTTON_NEXT' | translate}}
  </button>
}

<!-- Previous button with matStepperPrevious -->
@if (type === 'previous') {
  <button
    matStepperPrevious
    [ngClass]="type"
    (click)="handleClick()">
    {{'GLOBAL_BUTTON_BACK' | translate}}
  </button>
}
